import { createActions, createReducer } from "reduxsauce";

import Immutable from "seamless-immutable";

/*
Global application types and creators

https://github.com/skellock/reduxsauce#createactions

import { Types, Creators } from '../actions';

 */

export const { Types, Creators } = createActions({
  // Request Data
  loadPath: ["path"],
  loadPathFailed: ["path"],
  listenToPath: ["path"],
  listenToPathFailed: ["path"],

  // Receive Data
  dataReceived: ["path", "data"]
});

/*
Initial State
*/
const initialState = Immutable({
  locations: {},
  registrations: {},
  questions: {
    adult: {},
    minor: {}
  }
});

/*
Reducer Functions
 */
const onDataReceived = (state = initialState, action) =>
  Immutable.setIn(state, action.path.split("/"), action.data);

/*
Reducer
 */
export default createReducer(initialState, {
  [Types.DATA_RECEIVED]: onDataReceived
});



// WEBPACK FOOTER //
// ./src/data/reducer.js